import { useEffect, useState } from 'react';
import { TableBuilder, TableBuilderColumn } from 'baseui/table-semantic';
import { StatefulTooltip } from 'baseui/tooltip';
import { getProjectPriceChanges } from '@gtintel/platform-api';
import { formatDateTime, getDaysSince } from '@gtintel/platform-utils';
import * as S from '../styles';
import ValueChangeCell from './ValueChangeCell';
const PriceChangeTable = ({
  projectId
}) => {
  const [priceChanges, setPriceChanges] = useState([]);
  useEffect(() => {
    getProjectPriceChanges(projectId).then(changes => setPriceChanges(changes.results)).catch(() => {});
  }, [projectId]);

  // TODO: Pagination. We're unlikely to get more than 10 entries here so it's not a priority.
  return <S.Container>
      <S.Header>Recent Changes</S.Header>
      <TableBuilder data={priceChanges} emptyMessage={<h1>Nothing here yet</h1>}>
        <TableBuilderColumn header="Date">
          {row => <StatefulTooltip content={formatDateTime(row.change_date)} showArrow placement="top">
              <p> {getDaysSince(row.change_date)} days ago</p>
            </StatefulTooltip>}
        </TableBuilderColumn>
        <TableBuilderColumn header="Revenue">
          {row => {
          return <ValueChangeCell old_value={row.old_revenue.toLocaleString() + row.old_currency.toUpperCase()} new_value={row.new_revenue.toLocaleString() + row.new_currency.toUpperCase()} />;
        }}
        </TableBuilderColumn>
        <TableBuilderColumn header="Cost">
          {row => {
          return <ValueChangeCell old_value={row.old_cost.toLocaleString() + row.old_currency.toUpperCase()} new_value={row.new_cost.toLocaleString() + row.new_currency.toUpperCase()} />;
        }}
        </TableBuilderColumn>
        <TableBuilderColumn header="Changed By">
          {row => row.actor}
        </TableBuilderColumn>
      </TableBuilder>
    </S.Container>;
};
export default PriceChangeTable;